import { type PropsWithChildren } from "react";
import AnimateFrom from "./AnimateFrom";

const FadeIn = (props: PropsWithChildren) => {
    return <AnimateFrom style={{ opacity: 0 }}>{props.children}</AnimateFrom>;
}

export default FadeIn;